<template>
    <div class="search-result page">
        <div class="search-result__head">
            <div class="container-xl">
                <h1>{{ lang('Kereses_keresett_kifejezes') }}</h1>
                <h2>{{ searchText }}</h2>
            </div>
        </div>        
        <div class="search-result__content">
            <div class="container-xl">
                <div class="row" v-if="searchResult.length > 0">                                      
                     <div class="col-12 col-md-8 col-xl-6 offset-md-2 offset-xl-3" v-for="item in pageList" :key="item.id + '_' + item.name">                        
                        <div v-if="item.type == 'category' || item.type == 'product' || item.type == 'recipe' || item.type == 'news' || item.type == 'career' || item.type == 'group'">                                                        
                            <SearchResultItem v-if="item != undefined" 
                                :id="item.id"
                                :name="item.name" 
                                :slug="item.slug"
                                :type="item.type"
                                :short_desc="item.short_description"
                                :slug_path="item.slug_path"
                                :from_table="item.from_table"                            
                            />                           
                        </div>
                    </div>
                     <div class="col-12 pager-links-wrap">
                        <div>
                            <button id="first" class="btn btn--green-border" @click="goToFirstPage()" v-if="currentPage != 1" :title="lang('pager_elso_oldal')"></button>
                            <button id="prev" class="btn btn--green-border" @click="goToPrevPage()" v-if="currentPage != 1" :title="lang('pager_elozo_oldal')"></button>
                        </div>
                        <ul class="pages">
                            <li v-for="index in numberOfPages" :key="index" :class="{'active': index == currentPage}" @click="goToIndexedPage(index)">
                                <span>{{index}}</span>
                            </li>
                        </ul>
                        <div>
                            <button id="next" class="btn btn--green-border" @click="goToNextPage()" v-if="currentPage != numberOfPages" :title="lang('pager_kovetkezo_oldal')"></button>
                            <button id="last" class="btn btn--green-border" @click="goToLastPage()" v-if="currentPage != numberOfPages" :title="lang('pager_utolso_oldal')"> </button>
                        </div>
                    </div>
                </div>
                <div class="row" v-else>
                    <div class="col-12 no-result">{{ lang("kereses_nincs_talalat")}}</div>
                </div>
            </div>   
        </div>              
    </div>
</template>

<script>
import axios from 'axios'
import SearchResultItem from '@/components/pagesComponents/searchResult/SearchResultItem.vue'

export default {
    data(){
        return{
            searchResult: [],
            goodResults: [],
            pageList: [],
            pageSize: 30,
            currentPage: 1
        }
    },
    components:{
        SearchResultItem
    },
    computed:{
        searchText(){
            return this.$store.getters.getSearchedText
        }, 
        numberOfPages(){
            return Math.ceil(this.searchResult.length / this.pageSize)
        }       
    },
    watch:{
        searchText (){
            this.getSearchResult()
        }
    },
    methods:{
         getSearchResult(){            
            let _this = this;

            axios.post(process.env.VUE_APP_BIFROST_API_URL + '/helper/searchtext', {
                text: _this.searchText
                },
                {
                    params:{
                        "language_id": this.$store.getters.getSelectedLang.id                         
                    }
                }
            ).then(response => {                                
                // console.log('text search', response.data)
                if (response.data.status === true){
                    console.log(_this.rankingResult(_this.searchText,response.data.items));
                    _this.searchResult = _this.rankingResult(_this.searchText,response.data.items);
                    // _this.selectedSearchResult()
                    _this.pagination()
                } else {
                    _this.searchResult = []
                }
                        
            }) .catch(function (error) {                                                          
                console.log(error)
            });
        },
        rankingResult(text,result)
        {
            var words = text.split(" ");
            for(var i = 0; i < result.length; i++)
            {
                var haveInTitle = false;
                var allHaveInTitle = true;
                for (var j in words){
                    if (result[i].name.toLowerCase().indexOf(words[j].toLowerCase()) >= 0 )
                    {
                        haveInTitle = true;
                    }
                    else{
                        allHaveInTitle = false;
                    }
                } 

                result[i].rank = 0;
                if (haveInTitle)
                     result[i].rank += 2;
                if (allHaveInTitle)
                     result[i].rank += 2;
                if (result[i].type == 'product'){
                    result[i].rank += 1;
                }
                result[i].rank += 1- result[i].name.length / 100
               
            }
             return result.sort( function compare( a, b ) {
                    if ( a.rank < b.rank ){
                        return 1;
                    }
                    if ( a.rank > b.rank ){
                        return -1;
                    }
                    return 0;
                    } );
        },
        // selectedSearchResult() {
        //     let goodResults = []

        //     this.searchResult.forEach(item => {
        //         if (item.type == 'category' || item.type == 'product' || item.type == 'recipe' || item.type == 'news' || item.type == 'career' || item.type == 'group') {
        //             goodResults.push(item)
        //         }
        //     });

        //     this.goodResults = goodResults
        // }
        pagination(){
            // let _this = this                                                                             

            this.getPageList()
        },
        getPageList() {
            let _this = this
            var begin = ((this.currentPage - 1) * this.pageSize);
            var end = begin + this.pageSize;

            _this.pageList = this.searchResult.slice(begin, end);                               
        },
        goToFirstPage(){
            this.currentPage = 1;
            this.getPageList();
        },        
        goToNextPage(){
            this.currentPage += 1;
            this.getPageList();
        },
        goToPrevPage(){
            this.currentPage -= 1;
            this.getPageList();
        },
        goToLastPage(){
            this.currentPage = this.numberOfPages;
            this.getPageList();
        },
        goToIndexedPage(pageNum){
            this.currentPage = pageNum;
            this.getPageList();
        }       
    },
    created(){
        if (this.searchText != '') {
            this.getSearchResult()
        }
        
    }
}
</script>